<template>
  <div>
    <div class="main_banner">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="7" md="7" sm="12">
            <div class="left_section">
              <h1>How to repay a loan</h1>
              <p>
                f you want to proceed with payment just choose the most convenient
                method from offered below: dragonpay payment system or bank transfer
                to Robocash bank account. And then follow steps of our easy instruction.
              </p>
              <p>
                Robocash also provides a possibility to prolong your loan if you can’t repay
                your loan at the specified time. In order to prolong your loan login into your
                personal cabinet using your registered phone number and password.
              </p>
            </div>
          </b-col>
          <b-col cols="12" lg="5" md="5" sm="12">
            <div class="right_section"></div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="repay_cont">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <div class="right_side">
              <repay-form />
            </div>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <div class="dragonpay">
              <h3>Pay via Bank Account</h3>
              <div class="d_content">
                <p>1. Enter your phone number and password you used for registration</p>
                <p>2. Click Repay</p>
                <p>3. You will be forwarded to your payment order</p>
                <p>4. Print the payment order</p>
                <p>4. Print the payment order</p>
                <p>5. Go with it to your bank department and make a payment transfer</p>
                <p>When entering the data, make sure that all the data is correct in order to prevent the transfer to a wrong account.</p>
                <p>Be aware that if you return funds through bank transfer, usually money comes to the company account within 24 hours, but sometimes this process can take up to five days. The transfer speed depends on the sending bank.</p>
                <p class="mt-5 text-danger">You have repaid the loan!</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import repayForm from "@/views/repayment/repayform.vue"

export default {
  components: {
    repayForm
  }
};
</script>

<style lang="scss" scoped>
.main_banner {
  width: 100%;
  background: url("../../assets/images/repayment/bg_ideaman.jpg");
  background-position: center;
  background-size: cover;
  position: relative;
  padding: 60px 0 100px;
  h1 {
    color: #fff;
    font-weight: 600;
  }
  p {
    color: #fff;
    margin-top: 20px;
  }
  .left_section {
    padding-left: 50px;
  }
}
.repay_cont {
  padding: 80px 0 60px;
  .right_side {
    position: relative;
    top: -120px;
    padding-right: 40px;
    .repay_form {
      padding: 30px;
      border-radius: 8px;
      background-color: white;
      box-shadow: 2.5px 4.33px 21.84px 2.16px rgba(0, 0, 0, 0.38);
      width: 100%;
      height: 500px;
      position: relative;
      h3 {
        font-weight: 600;
      }
      p {
        margin-top: 30px;
      }
      .btn-group {
        width: 100%;
        margin-bottom: 20px;
        .btn {
          height: 50px;
              background-color: #efcfd0;
              border: 0;
              color: #434343;
              font-weight: 600;
              box-shadow: none;
        }
        .btn:active, .btn:focus, .btn:active:focus, .btn.active {
          background: $base-color-red;
          color: #fff;
        }
      }
      form {
        .btn {
          width: 100%;
          margin-top: 20px;
          height: 50px;
          background: $base-color-red;
          border: 0;
          text-transform: uppercase;
          font-size: 16px;
        }
      }
    }
  }
  .dragonpay {
    h3 {
      font-weight: 600;
    }
    p {
      span {
        display: block;
        margin-top: 10px;
      }
    }
  }
}
@media (max-width: 768px) {
  .main_banner {
    background: url("../../assets/images/banner-blue.jpg");
    .left_section {
      padding-left: 0;
    }
  }
  .repay_cont {
    .right_side {
      padding-right: 0;
    }
    .dragonpay {
      position: relative;
      top: -60px;
    }
  }
}
</style>